import { apiClient } from "./client";
import type { DashboardResponse, StudentCabinetResponse, TeacherDashboardResponse } from "@/types/dashboard";

export async function fetchDashboard(branchId?: string): Promise<DashboardResponse> {
  const { data } = await apiClient.get<DashboardResponse>("/dashboard", { params: { branchId } });
  return data;
}

export async function fetchTeacherDashboard(): Promise<TeacherDashboardResponse> {
  const { data } = await apiClient.get<TeacherDashboardResponse>("/dashboard/teacher");
  return data;
}

export async function fetchStudentCabinet(): Promise<StudentCabinetResponse> {
  const { data } = await apiClient.get<StudentCabinetResponse>("/dashboard/student");
  return data;
}
